module.exports = __webpack_public_path__ + "img/menu_bottom_2.75be8e3a.svg";